import styled, { css } from 'styled-components';
import {
  cssColorValue,
  desktopCelloCanon,
  mobileCello,
  PopoverNavigation,
  PopoverNavigationItem,
  screenXsMin,
  semanticColors,
  spacer16,
  spacer20,
  spacer32,
  spacer4,
  spacer64,
  TextLink,
} from '@spotify-internal/encore-web/core';

const defaultVariantStyles = css`
  padding: ${spacer64} ${spacer20} ${spacer20};
  width: 280px;
`;

const withProfileLinksVariantStyles = css`
  padding: 60px ${spacer16} ${spacer16};
  min-width: 320px;
  max-width: 100vw;
`;

export const SideMenuNavigation = styled(PopoverNavigation)<{
  $variant: 'default' | 'withProfileLinks';
}>`
  background: ${cssColorValue(semanticColors.backgroundBase)};
  bottom: 0;
  display: flex;
  flex-direction: column;
  overflow: auto;
  position: fixed;
  inset-inline-end: 0;
  top: 0;
  ${({ $variant }) => ($variant === 'withProfileLinks' ? withProfileLinksVariantStyles : defaultVariantStyles)}

  &&:focus {
    outline: none;
  }
`;

export const SideMenuNavigationList = styled.ul<{
  $variant: 'default' | 'withProfileLinks';
}>`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  gap: ${({ $variant }) => ($variant === 'withProfileLinks' ? '16px' : '20px')};
  list-style-type: none;
  margin-bottom: ${spacer32};
  margin-top: 0;
  padding: 0;
`;

export const SideMenuNavigationItem = styled(PopoverNavigationItem)`
  ${desktopCelloCanon};

  @media (max-width: ${screenXsMin}) {
    ${mobileCello}
  }
`;

export const SideMenuNavigationLink = styled(TextLink)`
  && {
    color: ${cssColorValue(semanticColors.textBase)};
    text-decoration: none;
    ${desktopCelloCanon};

    &&:active,
    &&:hover,
    &&:focus {
      box-shadow: none;
      color: ${cssColorValue(semanticColors.textBase)};
      text-decoration: none;
    }

    &:focus {
      outline: 5px auto -webkit-focus-ring-color;
      outline-offset: ${spacer4};
    }

    @media (max-width: ${screenXsMin}) {
      ${mobileCello}
    }
  }
`;
